(function () {
  const PREVIEW_SECONDS = 8;
  const DRAG_THRESHOLD = 5;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const autoplayAllowed = !saveData && !reducedMotion;

  function initDragScroll(row) {
    if (!row || row.dataset.dragReady === 'true') return;
    row.dataset.dragReady = 'true';

    let isDown = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;

    row.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      isDown = true;
      moved = false;
      startX = event.clientX;
      startScroll = row.scrollLeft;
    });

    row.addEventListener('pointermove', (event) => {
      if (!isDown) return;
      const distance = event.clientX - startX;
      if (!moved && Math.abs(distance) < DRAG_THRESHOLD) return;
      if (!moved) {
        moved = true;
        row.classList.add('is-dragging');
        row.setPointerCapture(event.pointerId);
      }
      row.scrollLeft = startScroll - distance;
    });

    function endDrag(event) {
      if (!isDown) return;
      isDown = false;
      row.classList.remove('is-dragging');
      if (row.hasPointerCapture(event.pointerId)) {
        row.releasePointerCapture(event.pointerId);
      }
    }

    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);
    row.addEventListener('dragstart', (event) => event.preventDefault());

    row.addEventListener(
      'click',
      (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      },
      true
    );
  }

  function initProductVideos(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const modal = root.querySelector('.video-popup');
    const closeButton = root.querySelector('.video-popup-close');
    const thumbsWrap = root.querySelector('.video-popup-thumbs');
    const mainVideo = root.querySelector('.video-popup-main video');
    const row = root.querySelector('.product-videos__row');
    const slides = Array.from(root.querySelectorAll('.product-videos__item'));
    const cardVideos = Array.from(root.querySelectorAll('.product-videos__video'));
    const visibleVideos = new Set();

    initDragScroll(row);

    if (!modal || !thumbsWrap || !mainVideo || !slides.length) return;

    document.body.appendChild(modal);

    const items = slides.map((slide) => ({
      url: slide.dataset.videoUrl,
      thumb: slide.dataset.thumbUrl || '',
    }));

    function playCard(video) {
      if (!autoplayAllowed) return;
      if (!video.getAttribute('src') && video.dataset.src) {
        video.src = video.dataset.src;
      }
      video.play().catch(() => {});
    }

    cardVideos.forEach((video) => {
      video.addEventListener('playing', () => {
        const slide = video.closest('.product-videos__item');
        if (slide) slide.classList.add('is-playing');
      });

      video.addEventListener('timeupdate', () => {
        if (video.currentTime >= PREVIEW_SECONDS) {
          video.currentTime = 0;
        }
      });
    });

    if (autoplayAllowed && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            if (entry.isIntersecting) {
              visibleVideos.add(video);
              if (!modal.classList.contains('active')) playCard(video);
            } else {
              visibleVideos.delete(video);
              video.pause();
            }
          });
        },
        { rootMargin: '100px 0px', threshold: 0.2 }
      );
      cardVideos.forEach((video) => observer.observe(video));
    }

    function setActive(index) {
      const safeIndex = Math.min(Math.max(index, 0), items.length - 1);

      thumbsWrap.querySelectorAll('.video-popup-thumb').forEach((thumb) => {
        thumb.classList.toggle('is-active', Number(thumb.dataset.idx) === safeIndex);
      });

      mainVideo.pause();
      mainVideo.src = items[safeIndex].url;
      mainVideo.currentTime = 0;
      mainVideo.play().catch(() => {});
    }

    function openModal(index) {
      cardVideos.forEach((video) => video.pause());
      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('video-popup-open');
      setActive(index);
    }

    function closeModal() {
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('video-popup-open');
      mainVideo.pause();
      mainVideo.removeAttribute('src');
      mainVideo.load();
      visibleVideos.forEach(playCard);
    }

    thumbsWrap.innerHTML = items
      .map((item, index) => `<button type="button" class="video-popup-thumb" data-idx="${index}" aria-label="Video ${index + 1}"><img loading="lazy" alt="" src="${item.thumb}"></button>`)
      .join('');

    thumbsWrap.addEventListener('click', (event) => {
      const thumb = event.target.closest('.video-popup-thumb');
      if (!thumb) return;
      setActive(Number(thumb.dataset.idx));
    });

    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => openModal(index));
      slide.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openModal(index);
      });
    });

    if (closeButton) closeButton.addEventListener('click', closeModal);

    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('active')) closeModal();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-videos]').forEach(initProductVideos);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();